import { isString } from 'lodash/fp';

export default (date: Date | string) => (isString(date)
  ? new Date(date)
  : date
);
